type ImageOptions = {
  url: string
  hejaImagesBaseUrl: string
  faceDetection?: boolean
  crop?: string
  effect?: string
  gravity?: string
  width?: number
  height?: number
  maxRes?: boolean
  path?: string
}

type CloudinaryUrlOptions = {
  hejaImagesBaseUrl: string
  imageId: string
  crop?: string
  effect?: string
  gravity?: string
  width?: number
  height?: number
  isTeamApp: boolean
}

type HejaUrlOptions = {
  imageId: string
  width?: number
  height?: number
  path?: string
  faceDetection?: boolean
  maxRes?: boolean
  hejaImagesBaseUrl: string
}

export function getImageUrl({
  url: urlProp,
  crop,
  effect,
  gravity,
  width,
  height,
  faceDetection,
  maxRes,
  hejaImagesBaseUrl,
}: ImageOptions) {
  let parsedUrl
  try {
    parsedUrl = parseUrl(urlProp, hejaImagesBaseUrl)
  } catch (_error: any) {
    return urlProp
  }

  const { isCloudinaryUrl, isHejaUrl, imageId, isTeamApp, path } = parsedUrl

  if (isCloudinaryUrl) {
    return cloudinaryUrl({
      imageId,
      crop,
      effect,
      gravity,
      width,
      height,
      isTeamApp,
      hejaImagesBaseUrl,
    })
  }

  if (isHejaUrl) {
    return hejaUrl({
      imageId,
      width,
      height,
      path,
      faceDetection,
      maxRes,
      hejaImagesBaseUrl,
    })
  }

  return urlProp
}

function parseUrl(urlProp: string, hejaImagesBaseUrl: string) {
  const url = new URL(urlProp)
  const isCloudinaryUrl = url.hostname === 'res.cloudinary.com'
  const hejaBaseUrl = new URL(hejaImagesBaseUrl)
  let path = ''

  const isHejaUrl = url.hostname === hejaBaseUrl.hostname
  const split = url.pathname.split('/')

  const imageId = split.slice(-1)[0].split('.')[0]
  const isTeamApp = split[1] === 'teamapp'

  if (imageId.length === 0) {
    throw new Error('URL missing id')
  }

  if (isHejaUrl) {
    const pathSegments = split.slice(1, -1)
    if (pathSegments[0] === 'assets') {
      path = pathSegments.join('/')
    }
  }

  return {
    isCloudinaryUrl,
    isHejaUrl,
    imageId,
    isTeamApp,
    path,
  }
}

function cloudinaryUrl({
  imageId,
  crop,
  effect,
  gravity,
  width,
  height,
  isTeamApp,
  hejaImagesBaseUrl,
}: CloudinaryUrlOptions) {
  const cloudname = isTeamApp ? 'teamapp' : 'heja'
  const params = [
    'f_auto',
    'q_auto',
    crop ? `c_${crop}` : '',
    effect ? `e_${effect}` : '',
    gravity ? `g_${gravity}` : '',
    width ? `w_${width}` : '',
    height ? `h_${height}` : '',
  ]
    .filter(Boolean)
    .join(',')

  return `${hejaImagesBaseUrl}/${cloudname}/image/upload/${params}/${imageId}`
}

function hejaUrl({
  imageId,
  width,
  height,
  faceDetection,
  maxRes,
  path = '',
  hejaImagesBaseUrl,
}: HejaUrlOptions) {
  let params = ''
  if (width || height || faceDetection || maxRes) {
    if (width) {
      params += `width=${width}`
    }
    if (height) {
      params += `&height=${height}`
    }
    if (faceDetection) {
      params += '&faceDetection=true'
    }
    if (maxRes) {
      params += '&maxRes=true'
    }
    params = `?${params}`
  }

  if (path) {
    return `${hejaImagesBaseUrl}/${path}/${imageId}${params}`
  }

  return `${hejaImagesBaseUrl}/${imageId}${params}`
}
